"use client";

import React from "react";
import { useTheme, ThemeType } from "@/context/ThemeContext";
import { Sparkles, Moon, Sun, Trees, Compass, CalendarRange, Flame, Award } from "lucide-react";

interface ThemeOption {
  value: ThemeType;
  label: string;
  icon: React.ComponentType<any>;
}

const themeOptions: ThemeOption[] = [
  { value: "womens", label: "Women (Pink)", icon: Sparkles },
  { value: "mens", label: "Men (Dark)", icon: Moon },
  { value: "spring", label: "Spring", icon: Sun },
  { value: "summer", label: "Summer", icon: Compass },
  { value: "autumn", label: "Autumn", icon: CalendarRange },
  { value: "winter", label: "Winter", icon: Trees },
  { value: "sport-active", label: "Sport Active", icon: Flame },
  { value: "sport-club", label: "Sport Club", icon: Award },
  { value: "poker-bar", label: "Poker Bar", icon: Award },
];

export const ThemeSelector: React.FC = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="relative inline-block text-left">
      <div className="flex items-center gap-1">
        <label htmlFor="theme-select" className="text-xs uppercase tracking-widest text-foreground/60 hidden sm:inline">
          Aesthetic:
        </label>
        <select
          id="theme-select"
          value={theme}
          onChange={(e) => setTheme(e.target.value as ThemeType)}
          className="bg-background border border-border px-3 py-1 text-xs uppercase tracking-wider font-medium text-foreground cursor-pointer focus:outline-none focus:border-primary transition-colors duration-200"
        >
          {themeOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
export default ThemeSelector;
